import React from 'react';
import Plot from 'react-plotly.js';
// import TimeseriesData from 'assets/dummy_data/timeseries.json'

class TimeseriesPlot extends React.Component {

    constructor(props) {
        super(props)
        this.props = props
        this.state = props.state
        this.setState = props.setState
    }

    componentDidMount() {
        const TimeseriesData = this.props.data
        // const TimeseriesData = this.props.state.timeseriesData
        // console.log('plot plot',TimeseriesData)
        if(TimeseriesData){
            // const times = Object.keys(TimeseriesData[Object.keys(TimeseriesData)[0]])
            let wind_timeseries = [], capacity_timeseries = [], output_timeseries = [];
            // let wind_timeseries_f = [], capacity_timeseries_f = [], output_timeseries_f = [];
            let times = [], times_f = []
    
            Object.entries(TimeseriesData).map((v, k) => { //looping over sites
                const wind = [], capacity = [], output = [];
                const wind_f = [], capacity_f = [], output_f = [];
                let last_t = null, last_d = null;
                Object.keys(v[1]).map((t) => { //looping over times
                    let d=v[1][t]
                    // console.log('time',t,d)
                    if(d.actual){
                        times.push(t)
                        wind.push(d.wind)
                        capacity.push(d.capacity)
                        output.push(d.output)
                    }else{
                        if(last_d.actual){ //if the time right before was "actual" but the time now is "forecast", add the last "actual" time as the first forecast point for a continuous timeseries
                            times_f.push(last_t)
                            wind_f.push(last_d.wind)
                            capacity_f.push(last_d.capacity)
                            output_f.push(last_d.output)
                        }
                        times_f.push(t)
                        wind_f.push(d.wind)
                        capacity_f.push(d.capacity)
                        output_f.push(d.output)
                    }
                    last_t = t //save the last time to use in first instance of forecast
                    last_d = d //save the last time's data to use in first instance of forecast
                })
                wind_timeseries.push({
                    x: times,
                    y: wind,
                    type: 'scatter',
                    mode: 'lines+markers',
                    marker: { size: 1 },
                    line: { color: 'grey', width: 0.5 },
                    name: `${v[0]} actual`
                })
                wind_timeseries.push({
                    x: times_f,
                    y: wind_f,
                    type: 'scatter',
                    mode: 'lines+markers',
                    marker: { size: 1 },
                    line: { color: 'blue', width: 0.5 },
                    name: `${v[0]} forecast`
                })
    
                capacity_timeseries.push({
                    x: times,
                    y: capacity,
                    type: 'scatter',
                    mode: 'lines+markers',
                    marker: { size: 1 },
                    line: { color: 'grey', width: 0.5 },
                    name: `${v[0]} actual`
                })

                capacity_timeseries.push({
                    x: times_f,
                    y: capacity_f,
                    type: 'scatter',
                    mode: 'lines+markers',
                    marker: { size: 1 },
                    line: { color: 'blue', width: 0.5 },
                    name: `${v[0]} forecast`
                })
    
                output_timeseries.push({
                    x: times,
                    y: output,
                    type: 'scatter',
                    mode: 'lines+markers',
                    marker: { size: 1 },
                    line: { color: 'grey', width: 0.5 },
                    name: `${v[0]} actual`
                })
                output_timeseries.push({
                    x: times_f,
                    y: output_f,
                    type: 'scatter',
                    mode: 'lines+markers',
                    marker: { size: 1 },
                    line: { color: 'blue', width: 0.5,opacity:0.5 },
                    name: `${v[0]} forecast`
                })
            })        
    
            this.setState({
                wind: compute_mean(wind_timeseries, times, times_f)[1],
                capacity: compute_mean(capacity_timeseries, times,times_f)[1],
                output: compute_mean(output_timeseries, times,times_f)[1] * compute_mean(output_timeseries, times)[2],
                wind0: compute_mean(wind_timeseries, times, times_f)[3],
                capacity0: compute_mean(capacity_timeseries, times,times_f)[3],
                output0: compute_mean(output_timeseries, times,times_f)[3] * compute_mean(output_timeseries, times)[2],
                valid_time: times[times.length-compute_mean(output_timeseries, times)[4]]
                // wind_f: compute_mean(wind_timeseries, times_f,times_f)[1],
                // capacity_f: compute_mean(capacity_timeseries, times_f,times_f)[1],
                // output_f: compute_mean(output_timeseries, times_f,times_f)[1] * compute_mean(output_timeseries, times_f)[2]
            })
            this.wind = compute_mean(wind_timeseries, times,times_f)[0]
            this.capacity = compute_mean(capacity_timeseries, times,times_f)[0]
            this.output = compute_mean(output_timeseries, times,times_f)[0]
            this.valid_time = times[times.length-1]
            // console.log('TIMES',times)

            // this.wind_f = compute_mean(wind_timeseries, times_f)[0]
            // this.capacity_f = compute_mean(capacity_timeseries, times_f)[0]
            // this.output_f = compute_mean(output_timeseries_f, times_f)[0]
        }


    }

    render() {


        let data;
        if (this.wind && this.props.wind) data = this.wind
        if (this.capacity && this.props.capacity) data = this.capacity
        if (this.output && this.props.output) data = this.output
        // if (this.wind_f && this.props.wind_f) data = this.wind_f
        // if (this.capacity_f && this.props.capacity_f) data = this.capacity_f
        // if (this.output_f && this.props.output_f) data = this.output_f
        console.log('valid_time',this.valid_time)


        return (
            this.wind || this.capacity || this.output ?
            // this.wind_f || this.capacity_f || this.output_f ?
                <Plot
                    style={{
                        width: '100%',
                        height: '100%',
                    }}
                    data={data}
                    useResizeHandler={true}
                    layout={{
                        margin: { l: 40, r: 20, b: 70, t: 10, pad: 5 },
                        showlegend: false,
                        width: undefined,
                        height: undefined,
                        autosize: true,
                        shapes: [{
                            type: 'line',
                            x0: this.valid_time,
                            y0: 0,
                            x1: this.valid_time,
                            yref: 'paper',
                            y1: 1,
                            }],
                    }}
                /> : null
        );
    }
}

export default TimeseriesPlot;

function compute_mean(data, times, times_f) {
    // console.log('times',times_f)
    let all_data = [], all_data_f = [], means = [], means_f = [], final_data = [];

    data.forEach(e => {
        // console.log('data',e.name.includes('forecast'))
        final_data.push(e)
        if(e.name.includes('forecast'))all_data_f.push(e.y)
        else all_data.push(e.y)
    })

    // console.log("all_data",all_data)
    all_data = all_data[0].map((_, colIndex) => all_data.map(row => row[colIndex]));
    all_data_f = all_data_f[0].map((_, colIndex) => all_data_f.map(row => row[colIndex]));
    all_data.forEach(e => means.push(mean_calc(e)))
    all_data_f.forEach(e => means_f.push(mean_calc(e)))
    
    final_data.push({
        x: times,
        y: means,
        type: 'scatter',
        mode: 'lines+markers',
        marker: { size: 1 },
        line: { color: 'black', width: 3 },
        name: 'Actual Mean',
        layout:{showlegend: true}
    })
    final_data.push({
        x: times_f,
        y: means_f,
        type: 'scatter',
        mode: 'lines+markers',
        marker: { size: 1 },
        line: { color: 'blue', width: 3 },
        name: 'Forecast Mean',
        layout:{showlegend: true}
    })

    console.log('all_data',means[means.length - 1],means)

    let ii=2
    let curr_mean = means[means.length - 1]
    while(!curr_mean){
        curr_mean = means[means.length - ii]
        ii+=1
    }

    return [final_data, curr_mean, all_data[0].length, means[0], ii-1];
}


function mean_calc(array){
    let sum = 0
    array.forEach(a=>sum+=a)
    return sum/array.length
    
}
